module.exports = __webpack_public_path__ + "static/media/img_001_copy_2-360.cfa3851c.webp";